import Layout from "../../../vendor_core/core/src/utils/Layout";
import Utils from "../../../vendor_core/core/src/utils/Utils";
import TextField from "../../../vendor_core/core/src/views/components/TextField";
import BitmapTextField from "../../../vendor_core/core/src/views/components/BitmapTextField";
import SymbolAnimation from "../../../vendor_core/core/src/views/SymbolAnimation";

export default class MYSymbolAnimation extends SymbolAnimation {

    // set dataName param to can create multiple and diferent bmp font of overlay obj
    showTextOverlay(
        id: number,
        content: string,
        dataName?: string
    ) {
        if (!this.overlaySticker) {
            return;
        }
        let symSpriteId: number | string = this.config.symbolAssetsMap[
            id || this.id
        ].name;
        const overlayData = this.config.overlayData[symSpriteId][dataName];
        if (!overlayData) {
            return;
        }
        let isText = overlayData.fontStyle;
        let isBmp = overlayData.bitmapFont;
        let textureBounds = Utils.deepClone(
            this.positionDefinitions.get(
                "overlay_" + symSpriteId
            )
        );
        if(!isText || !textureBounds) {
            return;
        }

        let textBound = Utils.deepClone(textureBounds);

        let text:TextField|BitmapTextField;
        if(isBmp) {
            textBound.x = 0;
            textBound.y = 0;
            text = new BitmapTextField(content, {
                    fontName: overlayData.fontStyle,
                    fontSize: Layout.scalePixels(overlayData.fontSize)
                },
                {
                    bound: textBound,
                    anchor: {
                        x: 0,
                        y: 0
                    }
                }
            );
            text.x = Layout.scalePixels(this.bounds.x + this.bounds.width / 2 - textureBounds.x - textureBounds.width / 2) - text.width/2;
            text.y = Layout.scalePixels(this.bounds.y - textureBounds.y  -  textureBounds.height + this.bounds.height/2) ;
            text.anchor.set(0.5, 0.5);
            text.applyBound();
        } else {
            text = new TextField(content,overlayData,{
                bound:textBound,
                anchor: {
                    x: 0.5,
                    y: 0
                }
            })
        }

        this.overlaySticker.addChild(text);
        this.overlaySticker.visible = true;
        return text;
    }

    public getTextOverlay(id: number = 0) {
        if (this.overlaySticker.children.length > 1) {
            return this.overlaySticker.children[id];
        } else {
            return undefined;
        }
    }
}
